import React from 'react';
import { ArrowRight } from 'lucide-react';
import { siteData } from '../mock';

const Hero = () => {
  return (
    <section id="hero" className="relative min-h-screen overflow-hidden bg-black pt-28">
      <div className="absolute inset-0 bg-[radial-gradient(circle_at_top_right,rgba(255,209,231,0.18),transparent_22%),radial-gradient(circle_at_bottom_left,rgba(255,209,231,0.1),transparent_25%)]" />
      <div className="grain-overlay opacity-30"></div>

      <div className="relative z-10 mx-auto flex min-h-screen max-w-7xl flex-col justify-between px-4 pb-10 lg:px-8">
        <div className="grid flex-1 items-center gap-12 lg:grid-cols-[1.35fr_0.75fr]">
          <div className="max-w-4xl">
            <p className="mb-6 font-mono text-xs uppercase tracking-[0.3em] text-pink-accent opacity-90">
              {siteData.eyebrow}
            </p>

            <h1 className="hero-brand-text mb-6 animate-fade-in">
              {siteData.brand.split(' ').map((word) => (
                <span key={word} className="hero-brand-line block">
                  {word}
                </span>
              ))}
            </h1>

            <p className="mb-5 max-w-3xl text-2xl font-medium leading-tight text-white/95 md:text-4xl">
              {siteData.tagline}
            </p>

            <p className="hero-tagline max-w-2xl text-base text-white/70 md:text-xl">
              {siteData.intro}
            </p>

            <div className="mt-10 flex flex-wrap items-center gap-4">
              <a
                href={siteData.ctas.primary.href}
                className="cta-button large border-pink-accent bg-pink-accent text-black hover:bg-white hover:border-white"
              >
                {siteData.ctas.primary.label}
              </a>
              <a
                href={siteData.ctas.secondary.href}
                target="_blank"
                rel="noopener noreferrer"
                className="cta-button large border-white/30 bg-white/5 text-white hover:border-pink-accent hover:text-pink-accent"
              >
                {siteData.ctas.secondary.label}
                <ArrowRight size={16} className="ml-2" />
              </a>
            </div>
          </div>

          <div className="lg:justify-self-end">
            <div className="rounded-[2rem] border border-white/10 bg-white/[0.03] p-6 backdrop-blur-sm">
              <div className="mb-6 flex items-center justify-between">
                <span className="font-mono text-xs uppercase tracking-[0.25em] text-white/45">
                  Current frame
                </span>
                <span className="rounded-full border border-pink-accent/30 px-3 py-1 font-mono text-[10px] uppercase tracking-[0.25em] text-pink-accent">
                  in motion
                </span>
              </div>

              <div className="space-y-4">
                {siteData.signalStrip.map((item) => (
                  <div key={item} className="flex items-center justify-between border-b border-white/8 pb-4 last:border-0 last:pb-0">
                    <span className="text-sm uppercase tracking-[0.2em] text-white/45">signal</span>
                    <span className="text-right text-sm text-white/82">{item}</span>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>

        <div className="mt-10 flex items-center gap-3 text-white/40">
          <div className="h-px flex-1 bg-white/10" />
          <span className="font-mono text-[11px] uppercase tracking-[0.3em]">selected work below</span>
          <div className="h-px flex-1 bg-white/10" />
        </div>
      </div>
    </section>
  );
};

export default Hero;
